import { Box, Button, Group, Paper, SimpleGrid, Skeleton, Text } from '@mantine/core';
import styles from './LoadMorePagination.module.sass';

const SKELETON_HEIGHT = 20;

type LoadMorePaginationProps = {
  loaded: number;
  total: number;
  hasMore: boolean;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  onLoadMore: () => void;
};

export const LoadMorePagination = ({
  loaded,
  total,
  hasMore,
  isLoading = false,
  isLoadingMore = false,
  onLoadMore,
}: LoadMorePaginationProps) => (
  <SimpleGrid cols={3} spacing="md">
    <Box />
    <Group justify="center">
      <Button
        className={styles.loadMoreButton}
        variant="default"
        disabled={isLoading || isLoadingMore || !hasMore}
        loading={isLoadingMore}
        onClick={onLoadMore}
      >
        {isLoadingMore ? 'Loading...' : hasMore ? 'Load More' : 'No More Results'}
      </Button>
    </Group>
    <Group justify="flex-end">
      <Paper className={styles.paginationCounter} py="xs" px="md" radius="md">
        {isLoading ? <Skeleton height={SKELETON_HEIGHT} radius="sm" /> : <Text>{`${loaded} / ${total}`}</Text>}
      </Paper>
    </Group>
  </SimpleGrid>
);
